module.exports = __webpack_public_path__ + "img/kknn07.1a6c5add.jpg";